import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { ALARM_TIMELINE_EXPORT } from './url-constants';

type AlarmTimelineExportEndpointSpecification = ApiEndpointSpecification;
export const AlarmTimelineExportEndpointSpecification: AlarmTimelineExportEndpointSpecification = {
    url: ALARM_TIMELINE_EXPORT,
    method: HttpMethod.GET,
    requestParamsSchemaName: 'AlarmTimelineExportRequestParams',
    requestBodySchemaName: 'AlarmTimelineExportRequestBody',
    okResponseSchemaName: 'AlarmTimelineExportOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
};

export const invokeAlarmTimelineExport = Helpers.makeApiRequestFn<
    Types.AlarmTimelineExportRequestParams,
    Types.AlarmTimelineExportRequestBody,
    Types.AlarmTimelineExportOkResponse
>(AlarmTimelineExportEndpointSpecification);
